import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { FormContextProvider, DisplaySpinnerContext } from "../../../context/ContextIndex";
import { AppForm, DynamicFormContainer, notifyToast, ToastType, TabPanel } from "../../../components";
import { getZoneDefaultValue, getZoneSchema } from "./Schema";
import { selectSessionConfig } from "../../../store/store-selector";
import { useFetchListData } from "../../../hooks/useFetchListData";
import { saveZone } from "../api-handler/api-handler";
import AppFormRootContainer from "../../../components/app-components/app-form-root-container/AppFormRootContainer";

const CreateZoneForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const EditZoneLocationId = searchParams.get("zoneLocationId");
  const spinnerCtx = useContext(DisplaySpinnerContext);
  const settingsConfig = useSelector(selectSessionConfig);
  const navigationData = location.state;
  const LocationList = useFetchListData(settingsConfig.businessCode, settingsConfig.countryCode, "getLocation", "location");

  const [formdata, setFormdata] = useState({
    schema: getZoneSchema([{ id: null, label: null }], EditZoneLocationId),
    appformdata: null,
  });

  const defaultValue = getZoneDefaultValue();

  const handleCancel = () => {
    try {
      navigate("/zonelist");
    } catch (err) {
      alert(err);
    }
  };

  const onZoneSubmit = async (data, formhandler) => {
    console.log("onZoneSubmit");
    const { reset, clearErrors } = formhandler;
    try {
      clearErrors();
      spinnerCtx.setLoadingIndicator(true);
      const status = await saveZone(data, {
        EditZoneLocationId,
        settingsConfig,
        formdata: formdata.appformdata,
      });

      if (status?.responseStatus === 200) {
        notifyToast("Sent for Approval", ToastType.SUCCESS);
        handleCancel();
      } else {
        notifyToast(status.errorMessage ? status.errorMessage : "Zone creation failed", ToastType.ERROR);
        spinnerCtx.setLoadingIndicator(false);
      }
      if (status?.error) {
        reset(
          { ...data },
          {
            keepValues: true,
            keepSubmitCount: false,
            keepDirty: true,
            keepTouched: true,
          }
        );
      }
    } catch (err) {
      reset(
        { ...data },
        {
          keepValues: true,
          keepSubmitCount: false,
          keepDirty: true,
          keepTouched: true,
        }
      );
      alert(err);
    }
  };

  useEffect(() => {
    const setFormSchema = (recordlist) => {
      try {
        let _locationList = [];
        if (recordlist.length) {
          let _formData = navigationData ? { ...navigationData } : null;

          _locationList = recordlist.map((item) => {
            if (_formData && item.LocationId === _formData.LocationId) {
              _formData.location = {
                id: item.LocationId,
                label: item.LocationName,
              };
            }
            return {
              id: item.LocationId,
              label: item.LocationName,
            };
          });

          if (_formData) {
            setFormdata((prevstate) => ({
              ...prevstate,
              schema: getZoneSchema(_locationList, EditZoneLocationId),
              appformdata: getZoneDefaultValue(_formData),
            }));
          } else {
            setFormdata((prevstate) => ({
              ...prevstate,
              schema: getZoneSchema(_locationList),
            }));
          }
        }
      } catch (err) {
        alert(err);
      } finally {
        spinnerCtx.setLoadingIndicator(false);
      }
    };

    spinnerCtx.setLoadingIndicator(true);
    if (LocationList) {
      setFormSchema(LocationList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [LocationList]);

  return (
    <AppFormRootContainer>
      <TabPanel
        tabs={[
          {
            icon: "",
            label: t("navigationMenu.zone"),
            children: (
              <FormContextProvider schema={formdata.schema} defaultValues={defaultValue} appformdata={formdata.appformdata}>
                <AppForm onSubmit={onZoneSubmit}>
                  <DynamicFormContainer
                    header={EditZoneLocationId ? t("createZone.editZone") : t("createZone.header")}
                    onCancel={handleCancel}
                  />
                </AppForm>
              </FormContextProvider>
            ),
          },
        ]}
        selectedTab="0"
        onTabChange={() => { }}
      />
    </AppFormRootContainer>
  );
};

export default CreateZoneForm;
